import {getTimeZoneDate} from "../../../helpers/data-format";

interface SyncCompletionToastProps {
  message: string;
  onRefresh: () => void;
  onClose: () => void;
  lastSyncedAt: string;
}

const SyncCompletionToast: React.FC<SyncCompletionToastProps> = ({ message, onRefresh, onClose, lastSyncedAt }) => (
  <div className="fixed top-4 right-4 z-50 bg-white dark:bg-gray-800 border border-green-200 dark:border-green-700 rounded-lg shadow-lg p-4 min-w-[350px] max-w-[400px]">
    <div className="flex items-start gap-3">
      <div className="flex-shrink-0 w-6 h-6 bg-green-100 dark:bg-green-900 rounded-full flex items-center justify-center">
        <svg className="w-4 h-4 text-green-600 dark:text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
        </svg>
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium text-gray-900 dark:text-white">Sync Completed</p>
        <p className="text-sm text-gray-600 dark:text-gray-300 mt-1">{message}</p>
        <p className="text-xs text-gray-500 dark:text-gray-400 mt-1 text-left">
          {lastSyncedAt ? `Last synced: ${getTimeZoneDate(lastSyncedAt, "lll")}` : 'Last synced: Never'}
        </p>
      </div>
      <button
        onClick={onClose}
        className="flex-shrink-0 ml-2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
      >
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
    <div className="mt-3 flex gap-2">
      <button
        onClick={onRefresh}
        className="flex items-center gap-1 px-3 py-1.5 bg-green-600 hover:bg-green-700 text-white text-sm rounded-md font-medium transition-colors"
      >
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
        </svg>
        Refresh
      </button>
    </div>
  </div>
);

export default SyncCompletionToast;